import { E as EVENTS } from "./events-58bc9098.js";
import { addToCart, setButtonLoading, parseFreeGifts } from "./cart-utils.js";

class ProductBlockComplementaryProducts extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      block: "[js-product-block-complementary-products-component]",
      item: "[js-complementary-product-item]",
      sliderComponent: "[js-scroll-slider-component]",
      addButton: ".complementary-product-item__add-button",
    };
  }

  connectedCallback() {
    this.controller = new AbortController();

    if (this.dataset.productSource === "app") {
      this.#loadAppProducts();
    }

    this.#attachEventListeners();
  }

  #attachEventListeners() {
    this.addEventListener(
      "click",
      (e) => {
        const button = e.target.closest(this.selectors.addButton);
        if (!button) return;

        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") {
          e.stopImmediatePropagation();
        }

        if (button.tagName === "BUTTON") {
          this.#handleAddToCart(button);
        }
      },
      { capture: true, signal: this.controller.signal }
    );
  }

  #handleAddToCart(button) {
    const item = button.closest(this.selectors.item);
    const variantId =
      item?.getAttribute("data-variant-id") || button.getAttribute("data-variant-id") || "";
    const sellingPlanId =
      item?.getAttribute("data-selling-plan-id") ||
      button.getAttribute("data-selling-plan-id") ||
      "";

    const freeGifts = parseFreeGifts(item);
    const mainProduct = {
      id: item?.dataset.mainProductId || "",
      variantId: variantId,
      name: item?.dataset.mainProductName || "",
      image: item?.dataset.mainProductImage || "",
    };

    if (!variantId) {
      return;
    }

    if (button.dataset.loading === "1") {
      return;
    }

    setButtonLoading(button, true, "complementary-product-item__add-button--loading");

    const stop = () => {
      document.removeEventListener(EVENTS.CART_CHANGED, onCartChange, true);
      clearTimeout(fallbackTimer);
      setButtonLoading(button, false, "complementary-product-item__add-button--loading");
    };

    const onCartChange = () => {
      stop();
    };

    document.addEventListener(EVENTS.CART_CHANGED, onCartChange, true);
    const fallbackTimer = window.setTimeout(() => {
      stop();
    }, 8000);

    addToCart(variantId, 1, sellingPlanId || undefined, this, {
      freeGifts,
      mainProduct,
    })
      .then(() => {})
      .catch(() => {
        stop();
      });
  }

  #loadAppProducts() {
    const url = `${window.theme.routes.productRecommendations}?section_id=${this.dataset.sectionId}&limit=${this.dataset.maxProducts}&product_id=${this.dataset.productId}&intent=complementary`;

    fetch(url)
      .then((res) => res.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, "text/html");
        const newSliderComponent = doc.querySelector(
          `${this.selectors.block} ${this.selectors.sliderComponent}`
        );
        const items = newSliderComponent.querySelectorAll(this.selectors.item);

        if (items.length > 0) {
          const sliderComponent = this.querySelector(
            this.selectors.sliderComponent
          );

          sliderComponent.replaceWith(newSliderComponent);
        } else {
          if (!Shopify.designMode) {
            this.style.display = "none";
          }
        }
      });
  }

  disconnectedCallback() {
    this.controller.abort();
  }
}

if (!customElements.get("product-block-complementary-products")) {
  customElements.define(
    "product-block-complementary-products",
    ProductBlockComplementaryProducts
  );
}